<template lang="pug">
  v-layout.box-proyeccion-desktop-formatter(
    column align-center
    :style="producto !== 'PLANGARANTIZADO' ? 'padding: 0 .5em;':'padding:1em 0em;'"
    )
    v-dialog(v-model="loader" persistent width="300")
      v-card(color="primary" dark="")
        v-card-text
          | Descargando PDF...
          v-progress-linear.mb-0(indeterminate="" color="white")
    PopupAlertMessage(
      @closeAlertPopup="closeAlertGoTo('Plan')"
      :openPopup="popupAlert.openPopup"
      :image="popupAlert.image"
      :title="popupAlert.title"
      :message="popupAlert.message"
      :messageButton="popupAlert.messageButton"
      :buttonClose="popupAlert.buttonClose"
      :imgHeight="popupAlert.imgHeight"
      :imgWidth="popupAlert.imgWidth"
      )
    v-flex(style="margin-bottom:0.5em;text-align: justify;line-height: 18px !important;")
      span(style="font-size: 14px;color: #454A6C;") {{ title }}
    v-flex.box-icon(style="margin:1em 0em")
      v-layout(column align-center style="position:relative")
        v-flex
          v-img
            img#box-icon-proyeccion(
              :src="iconView"
              style="height: 165px; width: 165px;"
            )
        v-flex(:style="`position: absolute;${producto !== 'PLANGARANTIZADO' ? 'top: 1.4em;' : 'top: 3.5em;'} text-align: center;transform: scaley(1.1) !important`")
          span#box-monto-proyeccion(:style="producto !== 'PLANGARANTIZADO' ? '' : 'color:#ffffff !important; text-shadow: 0px 4px 4px #027667 !important;'") {{montoProyeccion || ''}}
        v-flex.box-text
          span
            b Aquí verás tu proyección
    v-flex(style="margin-bottom:0.5em;")
      BoxTitleMonto(
        :title="producto !== 'PLANGARANTIZADO' ? 'Monto de Devolución':'Monto Asegurado'"
        :mensaje="tipoMoneda + (montoAsegurado || '0')"
        )
    v-flex.box-anho-proyeccion
      v-select(
        :items="items"
        label="Periodo anual"
        @input="periodoSeleccionadoMethod"
        solo
      )
    v-flex
      v-btn(@click="calcularProyeccion()" color="#EA0D90" style="height: 3em;width: 15em;")
        span(style="text-transform: none; color: #ffffff; font-size: 12px;") Calcular
    v-flex(style="width: 15em; text-align: center;margin:0.8em 0em")
      span(style="color: #454A6C;font-size: 12px;") Quiero descargar mi cuadro de resumen &nbsp;
        b(@click="valoresGarantizadosDonwload" style="color: #0855C4;text-decoration-line: underline;cursor:pointer") aquí

</template>

<script>
import * as d3 from 'd3'
import BoxTitleMonto from '../../components/generic/BoxTitleMonto.vue'
import { mapActions } from 'vuex'
import PopupAlertMessage from '../PopupAlertMessage.vue'
import Transacts from '@/interfaces/transacts'

export default {
  props: [
    'montoAsegurado',
    'periodos',
    'tipoMoneda',
    'numeroPoliza',
    'producto',
    'taggeo',
    'oriProducto'
  ],
  data () {
    return {
      iconView: null,
      gifView: null,
      gifPG: require('./../../assets/icons-mis-seguros/icon-mis-seguros-proyeccion3.gif'),
      iconPG: require('./../../assets/icons-mis-seguros/icon-mis-seguros-proyeccion1.svg'),
      gifVF: require('./../../assets/icons-mis-seguros/icon-mis-seguros-proyeccion-vf.gif'),
      iconVF: require('./../../assets/icons-mis-seguros/icon-mis-seguros-proyeccion-vf.svg'),
      items: [],
      valoresGarantizados: this.periodos,
      periodoSeleccionado: null,
      proyeccionSeleccionada: [],
      montoProyeccion: '',
      proyecciones: 0,
      title: '',
      popupAlert: {
        openPopup: false,
        image: require('@/assets/characters/informa.svg'),
        title: 'Estimado cliente',
        message: '',
        messageButton: 'Entendido',
        imgHeight: 150,
        imgWidth: 150
      },
      loader: false
    }
  },
  methods: {
    ...mapActions('user', ['getPDFTablaValoresGarantizados', 'getPDFTablaRescates']),
    ...mapActions('event', ['eventLog']),
    closeAlertGoTo (item) {
      this.$emit('closeAlertGoTo', item)
    },
    calcularProyeccion () {
      if (this.periodoSeleccionado) {
        let anio = this.periodoSeleccionado.split('años', 1)
        // filtrando proyeccion seleccionada
        this.proyeccionSeleccionada = this.valoresGarantizados.filter(dato => Number(dato.anho) === Number(anio[0]))
        // formateando monto
        const monto = (this.producto).toLowerCase().includes('free') ? this.proyeccionSeleccionada[0].rescate : ((this.producto || '').includes('VIDACASH') || (this.producto || '').toLowerCase() === Transacts.products.RUMBO || (this.oriProducto || '').toLowerCase() === Transacts.products.RUMBO ? this.proyeccionSeleccionada[0].rescate : this.proyeccionSeleccionada[0].sumaAsegurada)
        let auxMonto = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(monto)
        this.montoProyeccion = this.tipoMoneda + auxMonto

        let iconProyeccion = document.querySelector('#box-icon-proyeccion')
        iconProyeccion.src = this.gifView

        let montoProyeccion = d3.select('#box-monto-proyeccion')
        montoProyeccion.style('opacity', 0)
        montoProyeccion.transition().delay(2700).duration(800)
          .style('opacity', 1)
      } else {
        this.popupAlert.openPopup = true
        this.popupAlert.title = 'Estimado cliente'
        this.popupAlert.message = 'Debe de seleccionar un periodo'
      }
    },
    periodoSeleccionadoMethod (item) {
      this.periodoSeleccionado = item

      let iconProyeccion = document.querySelector('#box-icon-proyeccion')
      iconProyeccion.src = this.iconView

      let montoProyeccion = d3.select('#box-monto-proyeccion')
      montoProyeccion.transition().duration(500)
        .style('opacity', 0)
    },
    valoresGarantizadosDonwload () {
      let self = this
      self.loader = true
      const thenCallback = res => {
        self.loader = false
      }
      const catchCallback = () => {
        self.loader = false
        self.openPopupInfo = true
        self.popupAlert.image = require('@/assets/characters/informa.svg')
        self.popupAlert.title = 'Estimado cliente'
        self.popupAlert.message = 'No podemos realizar la descarga. Intente nuevamente en unos minutos.'
        self.popupAlert.messageButton = 'Entendido'
        setTimeout(() => {
          self.$root.$emit('showNps', {
            nombre: 'NPS - Inicio de Encuesta',
            funcionalidad: 'Descarga de cuadro de resumen',
            metadata: self.metadata
          })
        }, 3000)
      }
      if (self.producto.toLowerCase().includes('free') || (self.producto || '').includes('VIDACASH')) {
        this.getPDFTablaRescates({ numeroPoliza: this.numeroPoliza }).then(thenCallback).catch(catchCallback)
      } else {
        this.getPDFTablaValoresGarantizados({ numeroPoliza: this.numeroPoliza }).then(thenCallback).catch(catchCallback)
      }
    }
  },
  mounted () {
    d3.select('.box-proyeccion-desktop-formatter')
      .style('opacity', '0')
      .transition().duration(300)
      .style('opacity', '1')
    let self = this

    self.metadata = {
      numeroPoliza: self.taggeo.numeroPoliza,
      antiguedad: self.taggeo.antiguedad,
      productoConsultado: self.taggeo.ramo,
      subproductoConsultado: self.taggeo.nombreProducto
    }
    self.$root.$emit('npsInactivity', {seccion: 'Mis seguros - Proyección', metadata: self.metadata})

    self.eventLog({
      'tipoDocumento': self.taggeo.tipoDocumento,
      'numeroDocumento': self.taggeo.numeroDocumento,
      'categoria': 'Consulta',
      'nombre': self.taggeo.nombre,
      'datos': {
        'numeroPoliza': self.taggeo.numeroPoliza,
        'antiguedad': self.taggeo.antiguedad,
        'grupoProducto': self.taggeo.ramo,
        'producto': self.taggeo.nombreProducto,
        'dispositivo': 'desktop',
        'navegacion': 'Proyección'
      }
    })
    // ORDERNAR VALORES GARANTIZADOS
    let auxValoresGarantizados = []
    auxValoresGarantizados = self.valoresGarantizados ? self.valoresGarantizados.sort((a, b) => a.anho - b.anho) : []
    self.items = auxValoresGarantizados.map(data => Number(data.anho) + ' años')

    self.valoresGarantizados = auxValoresGarantizados
    if (this.producto !== 'PLANGARANTIZADO') {
      self.title = 'Visualiza como crecen tus ahorros más tu rentabilidad en el futuro, si no llega a ocurrir algún siniestro.'
      self.iconView = self.iconVF
      self.gifView = self.gifVF
    } else {
      self.title = 'Visualiza como crecen tus ahorros en el futuro.'
      self.iconView = self.iconPG
      self.gifView = self.gifPG
    }

    // TIENE INFO TABLA
    if (!self.periodos || self.periodos.length === 0 || self.oriProducto.includes('VIDA_CASH_PLUS')) {
      self.popupAlert.openPopup = true
      self.popupAlert.title = 'Estimado cliente'
      self.popupAlert.message = 'Por el momento no se encuentra activa esta funcionalidad.'
      self.popupAlert.messageButton = 'Entendido'
      self.popupAlert.buttonClose = false
    }
  },
  components: {
    BoxTitleMonto,
    PopupAlertMessage
  }

}
</script>

<style>
.box-anho-proyeccion .v-text-field.v-text-field--solo .v-label {
  top: calc(50% - 9px) !important;
  left: initial !important;
  right: initial !important;
  display: flex;
  justify-content: center;
  width: 100%;
  color: #000000;
  font-size: 13px;
  left: 10px !important;
}

.box-anho-proyeccion .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}

.box-anho-proyeccion .v-text-field.v-text-field--enclosed .v-text-field__details,
.v-text-field.v-text-field--enclosed>.v-input__control>.v-input__slot {
  padding: 0 12px;
}

.box-anho-proyeccion .theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
  border-radius: 2px;
  background: #fff;
  margin: 0;
  box-shadow: 0px 0px 0px 0px !important;
  border: 1px solid #919191;
  border-radius: 3px;
  min-height: 48px !important;
  height: 48px !important;
}

.box-anho-proyeccion .v-select__selection--comma {
  margin: 0em !important;
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 15px;
  left: 10px !important;

}

@media screen and (min-width: 360px) {

  .box-proyeccion-desktop-formatter .box-anho-proyeccion {
    width: 15em !important;
  }

  .box-proyeccion-desktop-formatter .box-icon .box-text {
    position: absolute;
    bottom: 1.1em;
    width: 6em;
    text-align: center;
    line-height: 0.7;
  }

  .box-proyeccion-desktop-formatter .box-icon .box-text span {
    color: var(--text-color);
    font-size: 9px
  }

  .box-proyeccion-desktop-formatter #box-icon-proyeccion {
    height: 165px;
    width: 165px;
  }

  .box-proyeccion-desktop-formatter #box-monto-proyeccion {
    color: var(--text-color);
    font-size: 18px !important;
    font-weight: bold;
    font-family: "Omnes Medium";
  }
}

@media screen and (min-width: 1200px) {
  .box-proyeccion-desktop-formatter .box-icon .box-text {
    position: absolute;
    bottom: 1.1em;
    width: 7em;
    text-align: center;
    line-height: 0.7;
  }

  .box-proyeccion-desktop-formatter .box-icon .box-text span {
    font-size: 10px
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mis-seguros/ProyeccionDesktop.vue